<template>
  <div id="expert-reviews-content">
    <ExpertReview
      v-for="(review, index) in reviews"
      :key="`er_${index}`"
      :review="review"
    />
  </div>
</template>
<script>
import ExpertReview from '@/components/pdp/molecules/ExpertReview.vue'
import { usePdpStore } from '@/stores/pdp'
import { mapState } from 'pinia'

export default {
  name: 'ExpertReviews',
  components: { ExpertReview },
  computed: {
    ...mapState(usePdpStore, { product: 'getApiV1Product' }),
    reviews() {
      return this.product.expert_reviews
    }
  }
}
</script>

<style scoped>
.rating {
  pointer-events: none;
}

.review-image div {
  height: 50px;
  width: 50px;
  margin: auto;
  background-size: cover;
  background-position: 50%;
  border-radius: 50%;
  border: 1px solid rgb(var(--v-theme-beige));
}

.expert-review {
  border-bottom: 2px solid rgb(var(--v-theme-light-beige));
}
</style>
